import {
  ServerFile1t91jzpzoixwe as ServerFile,
  ServerFile__toString_impl_4rulpa1zv5xkbnowbd9 as ServerFile__toString_impl_4rulpa,
  ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l as ServerFile__hashCode_impl_qj0ii5,
} from '../files/ServerFile.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ServerFileWithMetadata$Companion$$childSerializers$_anonymous__qwgro6() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ServerFileWithMetadata$Companion$$childSerializers$_anonymous__qwgro6_0() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ServerFileWithMetadata$Companion$$childSerializers$_anonymous__qwgro6);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t36_1 = [tmp_1, null, null, null, null, lazy(tmp_2, ServerFileWithMetadata$Companion$$childSerializers$_anonymous__qwgro6_0)];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.media.ServerFileWithMetadata', this, 6);
        tmp0_serialDesc.a1b('original', false);
        tmp0_serialDesc.a1b('mimeType', true);
        tmp0_serialDesc.a1b('size', true);
        tmp0_serialDesc.a1b('width', true);
        tmp0_serialDesc.a1b('height', true);
        tmp0_serialDesc.a1b('previews', true);
        this.m4m_1 = tmp0_serialDesc;
      }
      n4m(encoder, value) {
        var tmp0_desc = this.m4m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().t36_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), new (ServerFile())(value.y36_1));
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.z36_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.z36_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.a37_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, LongSerializer_getInstance(), value.a37_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.b37_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, IntSerializer_getInstance(), value.b37_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.c37_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, IntSerializer_getInstance(), value.c37_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.d37_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.d37_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n4m(encoder, value instanceof ServerFileWithMetadata() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m4m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance().t36_1;
        if (tmp10_input.a14()) {
          var tmp = tmp11_cached[0].f2();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.z13(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.z13(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.z13(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = tmp11_cached[0].f2();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp10_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.z13(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.z13(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.z13(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return ServerFileWithMetadata().o4m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.m4m_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance().t36_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), tmp0_cached[5].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ServerFileWithMetadataClass;
function ServerFileWithMetadata() {
  if (ServerFileWithMetadataClass === VOID) {
    class $ {
      constructor(original, mimeType, size, width, height, previews) {
        Companion_getInstance();
        mimeType = mimeType === VOID ? null : mimeType;
        size = size === VOID ? null : size;
        width = width === VOID ? null : width;
        height = height === VOID ? null : height;
        var tmp;
        if (previews === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = previews;
        }
        previews = tmp;
        this.y36_1 = original;
        this.z36_1 = mimeType;
        this.a37_1 = size;
        this.b37_1 = width;
        this.c37_1 = height;
        this.d37_1 = previews;
      }
      p4m(original, mimeType, size, width, height, previews) {
        return new (ServerFileWithMetadata())(original, mimeType, size, width, height, previews);
      }
      f37(original, mimeType, size, width, height, previews, $super) {
        original = original === VOID ? this.y36_1 : original;
        mimeType = mimeType === VOID ? this.z36_1 : mimeType;
        size = size === VOID ? this.a37_1 : size;
        width = width === VOID ? this.b37_1 : width;
        height = height === VOID ? this.c37_1 : height;
        previews = previews === VOID ? this.d37_1 : previews;
        return $super === VOID ? this.p4m(original, mimeType, size, width, height, previews) : $super.p4m.call(this, new (ServerFile())(original), mimeType, size, width, height, previews);
      }
      toString() {
        return 'ServerFileWithMetadata(original=' + ServerFile__toString_impl_4rulpa(this.y36_1) + ', mimeType=' + this.z36_1 + ', size=' + toString_0(this.a37_1) + ', width=' + this.b37_1 + ', height=' + this.c37_1 + ', previews=' + toString(this.d37_1) + ')';
      }
      hashCode() {
        var result = ServerFile__hashCode_impl_qj0ii5(this.y36_1);
        result = imul(result, 31) + (this.z36_1 == null ? 0 : getStringHashCode(this.z36_1)) | 0;
        result = imul(result, 31) + (this.a37_1 == null ? 0 : getBigIntHashCode(this.a37_1)) | 0;
        result = imul(result, 31) + (this.b37_1 == null ? 0 : this.b37_1) | 0;
        result = imul(result, 31) + (this.c37_1 == null ? 0 : this.c37_1) | 0;
        result = imul(result, 31) + hashCode(this.d37_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ServerFileWithMetadata()))
          return false;
        if (!(this.y36_1 === other.y36_1))
          return false;
        if (!(this.z36_1 == other.z36_1))
          return false;
        if (!(this.a37_1 == other.a37_1))
          return false;
        if (!(this.b37_1 == other.b37_1))
          return false;
        if (!(this.c37_1 == other.c37_1))
          return false;
        if (!equals(this.d37_1, other.d37_1))
          return false;
        return true;
      }
      static o4m(seen0, original, mimeType, size, width, height, previews, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().m4m_1);
        }
        var $this = createThis(this);
        $this.y36_1 = original;
        if (0 === (seen0 & 2))
          $this.z36_1 = null;
        else
          $this.z36_1 = mimeType;
        if (0 === (seen0 & 4))
          $this.a37_1 = null;
        else
          $this.a37_1 = size;
        if (0 === (seen0 & 8))
          $this.b37_1 = null;
        else
          $this.b37_1 = width;
        if (0 === (seen0 & 16))
          $this.c37_1 = null;
        else
          $this.c37_1 = height;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.d37_1 = emptyList();
        } else
          $this.d37_1 = previews;
        return $this;
      }
    }
    initMetadataForClass($, 'ServerFileWithMetadata', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ServerFileWithMetadataClass = $;
  }
  return ServerFileWithMetadataClass;
}
function ServerFileWithMetadataPreview$Companion$$childSerializers$_anonymous__1hd0ve() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k38_1 = [lazy(tmp_0, ServerFileWithMetadataPreview$Companion$$childSerializers$_anonymous__1hd0ve), null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.media.ServerFileWithMetadataPreview', this, 5);
        tmp0_serialDesc.a1b('file', false);
        tmp0_serialDesc.a1b('mimeType', false);
        tmp0_serialDesc.a1b('size', false);
        tmp0_serialDesc.a1b('width', true);
        tmp0_serialDesc.a1b('height', true);
        this.q4m_1 = tmp0_serialDesc;
      }
      r4m(encoder, value) {
        var tmp0_desc = this.q4m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().k38_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), new (ServerFile())(value.p38_1));
        tmp1_output.a15(tmp0_desc, 1, value.q38_1);
        tmp1_output.w14(tmp0_desc, 2, value.r38_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.s38_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, IntSerializer_getInstance(), value.s38_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.t38_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, IntSerializer_getInstance(), value.t38_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r4m(encoder, value instanceof ServerFileWithMetadataPreview() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q4m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0n;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_0().k38_1;
        if (tmp9_input.a14()) {
          var tmp = tmp10_cached[0].f2();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp9_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.r13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.z13(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = tmp10_cached[0].f2();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp9_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.r13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.z13(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return ServerFileWithMetadataPreview().s4m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.q4m_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_0().k38_1[0].f2(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var ServerFileWithMetadataPreviewClass;
function ServerFileWithMetadataPreview() {
  if (ServerFileWithMetadataPreviewClass === VOID) {
    class $ {
      constructor(file, mimeType, size, width, height) {
        Companion_getInstance_0();
        width = width === VOID ? null : width;
        height = height === VOID ? null : height;
        this.p38_1 = file;
        this.q38_1 = mimeType;
        this.r38_1 = size;
        this.s38_1 = width;
        this.t38_1 = height;
      }
      t4m(file, mimeType, size, width, height) {
        return new (ServerFileWithMetadataPreview())(file, mimeType, size, width, height);
      }
      v38(file, mimeType, size, width, height, $super) {
        file = file === VOID ? this.p38_1 : file;
        mimeType = mimeType === VOID ? this.q38_1 : mimeType;
        size = size === VOID ? this.r38_1 : size;
        width = width === VOID ? this.s38_1 : width;
        height = height === VOID ? this.t38_1 : height;
        return $super === VOID ? this.t4m(file, mimeType, size, width, height) : $super.t4m.call(this, new (ServerFile())(file), mimeType, size, width, height);
      }
      toString() {
        return 'ServerFileWithMetadataPreview(file=' + ServerFile__toString_impl_4rulpa(this.p38_1) + ', mimeType=' + this.q38_1 + ', size=' + this.r38_1.toString() + ', width=' + this.s38_1 + ', height=' + this.t38_1 + ')';
      }
      hashCode() {
        var result = ServerFile__hashCode_impl_qj0ii5(this.p38_1);
        result = imul(result, 31) + getStringHashCode(this.q38_1) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.r38_1) | 0;
        result = imul(result, 31) + (this.s38_1 == null ? 0 : this.s38_1) | 0;
        result = imul(result, 31) + (this.t38_1 == null ? 0 : this.t38_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ServerFileWithMetadataPreview()))
          return false;
        if (!(this.p38_1 === other.p38_1))
          return false;
        if (!(this.q38_1 === other.q38_1))
          return false;
        if (!(this.r38_1 === other.r38_1))
          return false;
        if (!(this.s38_1 == other.s38_1))
          return false;
        if (!(this.t38_1 == other.t38_1))
          return false;
        return true;
      }
      static s4m(seen0, file, mimeType, size, width, height, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_0().q4m_1);
        }
        var $this = createThis(this);
        $this.p38_1 = file;
        $this.q38_1 = mimeType;
        $this.r38_1 = size;
        if (0 === (seen0 & 8))
          $this.s38_1 = null;
        else
          $this.s38_1 = width;
        if (0 === (seen0 & 16))
          $this.t38_1 = null;
        else
          $this.t38_1 = height;
        return $this;
      }
    }
    initMetadataForClass($, 'ServerFileWithMetadataPreview', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    ServerFileWithMetadataPreviewClass = $;
  }
  return ServerFileWithMetadataPreviewClass;
}
//region block: exports
export {
  ServerFileWithMetadataPreview as ServerFileWithMetadataPreviewcbfnnbup1q22,
  ServerFileWithMetadata as ServerFileWithMetadata2wurhrhm98oms,
  Companion_getInstance as Companion_getInstance9bcftd4fcpen,
  Companion_getInstance_0 as Companion_getInstance3ribnrb9tntrx,
};
//endregion

//# sourceMappingURL=ServerFileWithMetadata.mjs.map
